<kh-button-radio-group [options]="options" [(value)]="value" (valueChange)="notifyChanged()"></kh-button-radio-group>
